import React from "react";
import Module from "./Module";
import {connect, useDispatch} from 'react-redux'
import Topbar from "./topbar";

import {useDrop} from "react-dnd";
import GlassPane from "./editor/glasspane";
import EditPanel from "./editor/edit_panel";
import {selectItem} from "../../data/actions";

import Zwop from "../power/zwop.tsx";

const Plan = ({uid, modules, root, bidib, app}) => {

    const showEditPopup = root.selected_item !== null
    const dispatch = useDispatch()

    const mynode = bidib && bidib.find(item => item.path === "0.0.0.0") || {version: ""}

    function closePane() {
        dispatch(selectItem(null))
    }

    const [{canDrop, isOver, clientOffset}, drop] = useDrop(() => ({
        accept: 'window',
        drop: (item, monitor) => ({
            id: uid,
            type: 'plan',
            clientOffset: monitor.getClientOffset(),
            initialClientOffset: monitor.getInitialClientOffset(),
            initialSourceClientOffset: monitor.getInitialSourceClientOffset(),
        }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
            clientOffset: monitor.getClientOffset(),
        })
    }))

    return (
        <div
            ref={drop}
            style={{
                color: '#3f320f',
                background: '#212c34',
                padding: "10px",
                height: window.innerHeight,
                width: '100%',
                overflow: 'hidden',
            }}
        >

            <Topbar scenario={uid}/>

            <GlassPane close={() => closePane()} show={showEditPopup}>
                <EditPanel item={root.selected_item || {}} bidib={bidib}/>
            </GlassPane>

            {modules && modules.map(it =>
                <Module key={it.id} modulid={it.id}/>
            )}

            <Zwop/>

            <div style={{
                position: 'fixed',
                bottom: 0,
                right: 0,
                color: 'rgb(197,180,119)',
                padding: 5,
            }}>{mynode && mynode.version}</div>
        </div>
    )
}

function mapStateToProps(state, other) {
    const ret = state.plan.items ? state.plan.items.filter(
        it => it.typename === "module" && it.scenario === other.uid
    ) : []
    return {modules: ret, root: state.root, bidib: state.bidib.data.node, app: state.bidib.data.app}
}

export default connect(mapStateToProps)(Plan)
